const updates = [
  {
    title: '《斗破苍穹》第500话重磅更新',
    desc: '萧炎突破斗皇境界，与魂殿正面交锋，惊天大战一触即发。',
    time: '10分钟前',
    tag: '最新更新',
  },
  {
    title: '《一人之下》新篇章开启',
    desc: '张楚岚身世之谜逐步揭晓，异人世界格局迎来巨变。',
    time: '30分钟前',
    tag: '章节更新',
  },
  {
    title: '《完美世界》动画联动特别篇上线',
    desc: '石昊再战强敌，动画与漫画剧情联动，双倍精彩不容错过。',
    time: '1小时前',
    tag: '特别企划',
  },
  {
    title: '新作推荐《长安十二时辰》漫画版',
    desc: '马伯庸同名小说改编漫画正式上线，大唐盛世下的悬疑故事。',
    time: '2小时前',
    tag: '新作上线',
  },
  {
    title: '《狐妖小红娘》镜花缘篇完结',
    desc: '涂山苏苏与白月初的故事暂告段落，感人结局引发全网热议。',
    time: '3小时前',
    tag: '篇章完结',
  },
  {
    title: '2024冬季新番一览表发布',
    desc: '本季多部人气漫画改编动画开播，漫画党提前预习原作正当时。',
    time: '5小时前',
    tag: '资讯速递',
  },
  {
    title: '《全职高手》特别篇彩蛋解析',
    desc: '官方放出隐藏剧情线，叶修退役前的故事首次曝光。',
    time: '6小时前',
    tag: '深度解析',
  },
  {
    title: '漫画阅读器全新升级公告',
    desc: '下拉式阅读体验优化，新增夜间模式和字号调节功能，阅读更舒适。',
    time: '8小时前',
    tag: '平台公告',
  },
];

const tagColors: Record<string, string> = {
  '最新更新': 'bg-primary-100 text-primary-600',
  '章节更新': 'bg-accent-100 text-accent-600',
  '特别企划': 'bg-accent-100 text-accent-600',
  '新作上线': 'bg-primary-100 text-primary-600',
  '篇章完结': 'bg-secondary-100 text-secondary-600',
  '资讯速递': 'bg-secondary-100 text-secondary-600',
  '深度解析': 'bg-primary-100 text-primary-600',
  '平台公告': 'bg-secondary-100 text-secondary-600',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-500">漫画圈的实时快讯，追更不迷路</p>
        </div>

        <div className="relative">
          <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-5">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pl-12 group cursor-pointer">
                <div className="absolute left-4 top-2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 group-hover:scale-125 transition-transform"></div>
                <div className="bg-background-50 rounded-xl p-4 md:p-5 hover:scale-[1.01] transition-transform">
                  <div className="flex items-center gap-2 mb-2">
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-600'}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}